import { EventBus } from "@/mixins/eventBus"

export function emitAlert(type: string, msg: string): void {
  EventBus.$emit(type, msg)
}
